// This file was auto generated by resource-sync tools.

import ar_translation from './ar/translation.json';
import en_translation from './en/translation.json';
import ptBR_translation from './pt-BR/translation.json';
import ur_translation from './ur/translation.json';
import zh_translation from './zh/translation.json';
import zhHK_translation from './zh-HK/translation.json';

const resources = {
    'namespaces': [{
        'i18nConfig': {"env":"prod","apiKey":"c8a8b802de0447359433a0aaa8e51bf8","projectId":6,"namespaceId":"mrel1kvabb","namespaceName":"translation"},
        'localeInfos': [{"locale":"ar","version":367},{"locale":"en","version":404},{"locale":"pt-BR","version":155},{"locale":"ur","version":31},{"locale":"zh","version":304},{"locale":"zh-HK","version":329}]
    }],
    'ar': {
        translation: ar_translation
    },
    'en': {
        translation: en_translation
    },
    'pt-BR': {
        translation: ptBR_translation
    },
    'ur': {
        translation: ur_translation
    },
    'zh': {
        translation: zh_translation
    },
    'zh-HK': {
        translation: zhHK_translation
    }
};

export default resources;